import React, { useEffect, useState } from 'react';
import { createUseStyles } from '../theming';
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@material-ui/core';

const useStyles = createUseStyles({
  title: {
    width: 400,
    '& h2': {
      color: 'rgba(0, 0, 0, 0.87)',
    },
  },
  error: {
    color: '#f44336',
    fontSize: '.75rem',
    padding: '0 25px',
  },
  formControl: {
    marginBottom: '16px !important',
  },
});

interface Props {
  open: boolean;
  title: string;
  description: string;
  confirmationText: string;
  onClose: () => void;
  onValidate: () => void;
}

const ConfirmationDialog: React.FC<Props> = ({ title, description, confirmationText, open, onClose, onValidate }) => {
  const [formError, setFormError] = useState<string | undefined>();
  const classes = useStyles();

  useEffect(() => {
    setFormError(undefined);
  }, [open]);

  const onSubmit = async () => {
    try {
      setFormError(undefined);
      await onValidate();
    } catch (e) {
      setFormError(e.message);
    }
  };

  return (
    <Dialog onClose={onClose} scroll='paper' open={open}>
      <DialogTitle className={classes.title}>{title}</DialogTitle>

      <DialogContent>{description}</DialogContent>

      <DialogActions>
        <Button type='button' onClick={onClose} color='primary'>
          Annuler
        </Button>

        <Button type='submit' color='primary' onClick={onSubmit}>
          {confirmationText}
        </Button>
      </DialogActions>

      {formError && <p className={classes.error}>{formError}</p>}
    </Dialog>
  );
};

export default ConfirmationDialog;
